const lista_precios = state => state.lista_precios;
const lista_precio_seleccionada = state => state.lista_precio_seleccionada;

export default {
  lista_precios,
  lista_precio_seleccionada,
};